module.exports = __webpack_public_path__ + "static/media/oesllp.9713c112.png";